import React, { Component } from 'react'
import EntityList from './../../components/entityList';

class KijijiTotalBudgets extends Component {
  render() {
    return (
      <EntityList apiRoute='api/kijijitotalbudgets' title='Budgets totaux Kijiji' editTitle='Budget total Kijiji' displayColumns={[
        {Description: 'Description', Column: 'Description'},
        {Description: 'Valeur', Column: 'Value'},
        {Description: 'Défaut', Column: 'Default'},
        {Description: 'Inactif', Column: 'Inactive', sortable: false, format: {type: 'boolean'}}
      ]}/>
    )
  }
}

export default KijijiTotalBudgets;


/** WEBPACK FOOTER **
 ** ./src/app/routes/trailers/kijijiTotalBudgets.js
 **/